document.addEventListener("DOMContentLoaded", (event) => {
  const filterBtn = document.querySelector("#mobile__filter--btn");
  const filterCloseBtn = document.querySelector("#filter_action--btn #close__icon");
  if (filterBtn != null) {
    filterBtn.addEventListener("click", function() {
      this.classList.add("opacity-0", "pointer-events-none", "hidden");
      document.querySelector("#filter__wrapper").classList.remove("max-h-0", "opacity-0", "overflow-hidden");
      document.querySelector("#filter__wrapper").classList.add("max-h-[200px]", "opacity-1", "overflow-visible");
    });
  }
  if (filterCloseBtn != null) {
    filterCloseBtn.addEventListener("click", function() {
      filterBtn.classList.remove("opacity-0", "pointer-events-none", "hidden");
      document.querySelector("#filter__wrapper").classList.remove("max-h-[200px]", "opacity-1", "overflow-visible");
      document.querySelector("#filter__wrapper").classList.add("max-h-0", "opacity-0", "overflow-hidden");
    });
  }
  var previousValue = [];
  function updateDropdownOptions(selectName, uniqueValues) {
    var selectDropdown = document.querySelector(`select[name="${selectName}"]`);
    var options = selectDropdown.options;
    var visibleOptionsCount = 0;
    for (var i = 0; i < options.length; i++) {
      var optionValue = options[i].value;
      if (i !== 1) {
        if (!uniqueValues.includes(optionValue)) {
          options[i].style.display = 'none';
        } else {
          options[i].style.display = 'block';
          visibleOptionsCount++;
        }
      } else {
        visibleOptionsCount++;
      }
    }

    if (visibleOptionsCount === 1) {
      selectDropdown.selectedIndex = 1;
    }
  }

  function handleDropdownChange() {
    document.querySelector("#filter_action--btn").removeAttribute("disabled");
    document.querySelector("#filter_action--btn #close__icon").classList.add("hidden");
    document.querySelector("#filter_action--btn #reset__icon").classList.remove("hidden");
    var deptDd = document.querySelector('.department-dropdown');
    var locDd = document.querySelector('.location-dropdown');
    var empDd = document.querySelector('.employee-dropdown');
    updateURLParam('department', deptDd.value);
    updateURLParam('location', locDd.value);
    updateURLParam('employment', empDd.value);
    document.querySelectorAll(`#careers-template__container .careers__category[data-department='${deptDd.value}']`);
    document.querySelectorAll(`#careers-template__container .careers__category`).forEach(el => {
      el.style.display = "none";
      el.classList.remove("filtered");
    })
    var deptVal = (deptDd.value == "") ? "" : `[data-department='${deptDd.value}']`;
    if (deptVal == "") {
      document.querySelectorAll(`#careers-template__container .careers__category`).forEach(el => {
        el.style.display = "block";
        el.classList.add("filtered");
      })
    } else {
      document.querySelector(`#careers-template__container .careers__category${deptVal}`).style.display = "block";
    }
    if (locDd.value != "" && empDd.value != "") {
      var elementsWithLocations = document.querySelectorAll(`#careers-template__container .careers__category${ deptVal } .careers-template__item`);
      elementsWithLocations.forEach(function(element) {
        var locationsAttribute = element.getAttribute('data-locations');
        var EmpTypeAttribute = element.getAttribute('data-employment-type');
        if (locationsAttribute && locationsAttribute.includes(locDd.value) && EmpTypeAttribute && EmpTypeAttribute.includes(empDd.value)) {
          element.style.display = 'flex';
          element.style.opacity = '1'
          element.classList.add("filtered");
        } else {
          element.style.display = 'none';
          element.classList.remove("filtered");
        }
      });
    } else if (locDd.value != "") {
      var elementsWithLocations = document.querySelectorAll(`#careers-template__container .careers__category${ deptVal } .careers-template__item`);
      elementsWithLocations.forEach(function(element) {
        var locationsAttribute = element.getAttribute('data-locations');
        if (locationsAttribute && locationsAttribute.includes(locDd.value)) {
          element.style.display = 'flex';
          element.style.opacity = '1'
          element.classList.add("filtered");
        } else {
          element.style.display = 'none';
          element.classList.remove("filtered");
        }
      });
    } else if (empDd.value != "") {
      var elementsWithLocations = document.querySelectorAll(`#careers-template__container .careers__category${ deptVal } .careers-template__item`);
      elementsWithLocations.forEach(function(element) {
        var locationsAttribute = element.getAttribute('data-employment-type');
        if (locationsAttribute && locationsAttribute.includes(empDd.value)) {
          element.style.display = 'flex';
          element.style.opacity = '1'
          element.classList.add("filtered");
        } else {
          element.style.display = 'none';
          element.classList.remove("filtered");
        }
      });
    } else {
      var elementsWithLocations = document.querySelectorAll(`#careers-template__container .careers__category${ deptVal } .careers-template__item`);
      elementsWithLocations.forEach(function(element) {
        element.style.display = 'flex';
        element.style.opacity = '1'
        element.classList.add("filtered");
      });
    }
    var divs = document.querySelectorAll('.careers__category .careers-template__item');
    var allLocations = Array.from(divs).reduce(function(locations, div) {
      var computedStyle = window.getComputedStyle(div);
      var displayValue = computedStyle.display;
      if (displayValue === 'flex') {
        var dataValue = "";
        if (window.getComputedStyle(div.closest(".careers__category")).display == "block") {
          var dataValue = div.getAttribute('data-locations');
        }
        if (dataValue) {
          var locationsArray = dataValue.split(',');
          locations.push(...locationsArray);
        }
      }
      return locations;
    }, []);
    var divs = document.querySelectorAll('.careers__category .careers-template__item');
    var allData = Array.from(divs).reduce(function(result, div) {
      var computedStyle = window.getComputedStyle(div);
      var displayValue = computedStyle.display;
      if (displayValue === 'flex' && window.getComputedStyle(div.closest(".careers__category")).display == "block") {
        var locationDataValue = div.getAttribute('data-locations');
        var employmentTypeDataValue = div.getAttribute('data-employment-type');
        if (locationDataValue) {
          var locationsArray = locationDataValue.split(',');
          result.locations.push(...locationsArray);
        }
        if (employmentTypeDataValue) {
          var employmentTypesArray = employmentTypeDataValue.split(',');
          result.employmentTypes.push(...employmentTypesArray);
        }
      }
      return result;
    }, {
      locations: [],
      employmentTypes: []
    });
    var uniqueLocations = Array.from(new Set(allData.locations));
    var uniqueEmploymentTypes = Array.from(new Set(allData.employmentTypes));
    updateDropdownOptions("locationId", uniqueLocations);
    updateDropdownOptions("employmentType", uniqueEmploymentTypes);
    document.querySelectorAll('.careers__category').forEach(category => {
      const items = category.querySelectorAll('.careers-template__item');
      const allHidden = Array.from(items).every(item => item.style.display === 'none');
      if (allHidden) {
        category.style.display = 'none';
      } else {
        // category.style.display = '';
      }
    });
    
    var divget = document.querySelectorAll(".careers-template__item");
    let counter = 0;
    divget.forEach(function(item) {
      if(item.style.display == 'flex' && item.parentNode.style.display != 'none'){
        counter ++;   
      }
    })
    document.querySelector("#careers-template__container h2 span").innerHTML = "(" + counter + ")";
  }
  
  var urlParams = new URLSearchParams(window.location.search);
  var departmentValue = urlParams.get('department');
  var locationValue = urlParams.get('location');
  var employmentValue = urlParams.get('employment');
  var dropdownItems = document.querySelectorAll('.filter__options--item');
  dropdownItems.forEach(function(item) {
    var dropdown = item.querySelector('.filter__select--item');
    switch (dropdown.name) {
      case "departmentId":
        dropdown.value = departmentValue;
        break;
      case "locationId":
        dropdown.value = locationValue;
        break;
      case "employmentType":
        dropdown.value = employmentValue;
        break;
    }
    handleDropdownChange(dropdown);
  });
  dropdownItems.forEach(function(item) {
    item.querySelector('.filter__select--item').addEventListener('change', function() {
      handleDropdownChange(this);
    });
  });
});

function updateURLParam(paramName, paramValue) {
  var url = new URL(window.location.href);
  url.searchParams.set(paramName, paramValue);
  window.history.replaceState({}, document.title, url.toString());
  var dropdowns = document.querySelectorAll('.filter__options--item select');
  var filterBtn = false;
  dropdowns.forEach(function(dropdown) {
    if (dropdown.value === '') {
      dropdown.options[1].selected = true;
    } else {
      filterBtn = true
    }
  });
  if (!filterBtn) {
    document.querySelector("#filter_action--btn").setAttribute("disabled", true)
    document.querySelector("#filter_action--btn #close__icon").classList.remove("hidden");
    document.querySelector("#filter_action--btn #reset__icon").classList.add("hidden");
  }
}

document.querySelector("#filter_action--btn").addEventListener("click", function() {
  var dropdowns = document.querySelectorAll('.filter__options--item select');

  function triggerSelection(index) {
    setTimeout(function() {
      if (dropdowns[index].options.length >= 2) {
        dropdowns[index].options[1].selected = true;
        var event = new Event('change');
        dropdowns[index].dispatchEvent(event);
      }
    }, index * 100);
  }
  for (var i = 0; i < dropdowns.length; i++) {
    triggerSelection(i);
  }
});